import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/countdown.json";
import fr from "@/locales/fr/puzzle-types/countdown.json";

export const COUNTDOWN_NS = "puzzle-types/countdown";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerCountdownTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", COUNTDOWN_NS))
    i18n.addResourceBundle("en", COUNTDOWN_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", COUNTDOWN_NS))
    i18n.addResourceBundle("fr", COUNTDOWN_NS, fr, true, true);
}
